export const capitalizeWord = (str) =>
  typeof str === 'string' || str instanceof String ?
    `${str.charAt(0).toUpperCase()}${str.slice(1)}` : str

export const convertToLowerCase = (str) =>
  typeof str === 'string' || str instanceof String ?
    str.toLowerCase() : str